import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { cloneDeep } from 'lodash';
import { take } from 'rxjs/operators';

@Pipe({
  name: 'translateLabels'
})
export class TranslateLabelsPipe implements PipeTransform {

  constructor(private translocoService: TranslocoService) {}

  async transform(value: any[], labelField: string = 'label'): Promise<any[]> {
    if (value) {
      const cloned = cloneDeep(value);
      await this.deepTransform(cloned, labelField);
      return cloned;
    }
    return value;
  }

  async deepTransform(items: any[], labelField: string) {
    for (const row of items) {
      row[labelField] = await this.translocoService.selectTranslate(row[labelField]).pipe(take(1)).toPromise();
      if (row.items) {
        await this.deepTransform(row.items, labelField);
      }
    }
  }

}
